import { IonPage, IonHeader, IonContent, IonItem, IonImg} from '@ionic/react';
import InnerMenu from '../components/InnerMenu';
import PageEventHandler from "../components/PageEventHandler"
import './Credits.css';
import { useContext } from 'react';
import { LanguageContext } from '../contexts/LanguageContext';
import { creditsTranslations } from '../translations/credits';
import NotificationRedirect from '../components/NotificationRedirect';  

const Credits: React.FC = () => {
  const { language } = useContext(LanguageContext);
  const t = creditsTranslations[language];

  return (
    <IonPage>
      <IonHeader>
        <InnerMenu name={t.pageTitle} />
      </IonHeader>
      <IonContent fullscreen>
        <IonItem lines="none">
          <h1 className="mainTit" slot="start">{t.pageTitle}</h1>
        </IonItem>
        <div className="ion-text-justify ion-padding">
          {t.content.split('\n\n').map((paragraph, index) => (
            <p key={index}>{paragraph}</p>
          ))}
           {t.lastLine1} <a href="https://www.adbpo.it" target="_blank">www.adbpo.it</a>, <a href="https://www.agenziapo.it" target="_blank">www.agenziapo.it</a>, <a href="https://www.pogrande.it" target="_blank">www.pogrande.it</a> {t.lastLine3}
        </div>
        <div className="footerBar">
          <a href="https://www.agenziapo.it" target="_blank"><IonImg class="ion-margin" slot="start" alt="Logo AIPO" src={`${process.env.PUBLIC_URL}/assets/images/logo_aipo_b2.png`} id="logoAipo" /></a>
          <a href="https://www.adbpo.it" target="_blank"><IonImg class="ion-margin" slot="start" alt="Logo ADBPO" src={`${process.env.PUBLIC_URL}/assets/images/adbpo_colore.png`} id="logoAdbpo" /></a>
        </div>
      </IonContent>
      <PageEventHandler pageIndex={12} dockIndex={0}/>
      <NotificationRedirect /> {/* redirect to the page specified in the local storage */}
    </IonPage>
  );
};

export default Credits;
